import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Store from "@/store";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: "/home",
    component: () =>
      import(/* webpackChunkName: "baseLayout" */ "@/layouts/BaseLayout.vue"),
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: "/home",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/HomeView.vue"),
        meta: {
          requiresAuth: false,
          title: "Tarjeta Pircana"
        }
      },
      {
        path: "/login",
        name: "login",
        component: () =>
          import(/* webpackChunkName: "home" */ "@/views/auth/LoginView.vue"),
        meta: {
          notLogged: true,
          requiresAuth: false,
          title: "Login"
        }
      },
      {
        path: "/signup",
        name: "signup",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/auth/RegisterView.vue"
          ),
        meta: {
          notLogged: true,
          requiresAuth: false,
          title: "Registro"
        }
      },
      {
        path: "/recuperar",
        name: "recuperar",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/auth/RecoverPassView.vue"
          ),
        meta: {
          notLogged: true,
          requiresAuth: false,
          title: "Recuperar"
        }
      },
      {
        path: "/preguntas-frecuentes",
        name: "Preguntas",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Preguntas/PreguntasFrecuentesView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Preguntas Frecuentes"
        }
      },
      {
        path: "/contacto",
        name: "Contacto",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Contacto/ContactoView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Contacto"
        }
      },
      {
        path: "/requisitos",
        name: "Requisitos",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Requisitos/RequisitosView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Requisitos"
        }
      },
      {
        path: "/categorias",
        name: "Categorias",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Beneficios/CategoriasView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Categorias"
        }
      },
      {
        path: "/convenios/:nombre",
        name: "Comercios",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Beneficios/ConveniosView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Comercios"
        }
      },
      {
        path: "/actividades/:nombre",
        name: "ListaActividades",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Actividades/ActividadesView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Comercios"
        }
      },
      {
        path: "/beneficio/:nombre",
        name: "Beneficio",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Beneficios/BeneficioView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Beneficio"
        }
      },
      {
        path: "/socios",
        name: "Socios",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/Socios/SociosView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Registrar como Socio"
        }
      },
      {
        path: "/privacidad",
        name: "Terminos",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/TerminosYCondicionesView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Términos y Condiciones"
        }
      },
      {
        path: "/vecinos",
        name: "ApplicationsList",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/views/Dashboard/ApplicationsListView.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Solicitudes"
        }
      },
      {
        path: "/validar",
        name: "Applications",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/components/Dashboard/Applications.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Validar"
        }
      },
      {
        path: "/solicitud/editar",
        name: "ApplicationEdit",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/components/Dashboard/Applications.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Editar"
        }
      },
      {
        path: "detalles/:id",
        name: "ApplicationDetails",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/components/Dashboard/ApplicationDetail.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Perfil"
        }
      },
      // {
      //   path: "/solicitud",
      //   name: "solicitud",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "panel-admin" */ "@/views/Dashboard/NewApplicationView.vue"
      //     ),
      //   meta: {
      //     requiresAuth: true,
      //     title: "Solicitud"
      //   }
      // },
      {
        path: "/nueva_solicitud",
        name: "solicitudNueva",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/views/Dashboard/SolicitudStepView.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Solicitud"
        }
      },
      {
        path: "/reenviar",
        name: "reenviar",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/auth/ValidateAccountView.vue"
          ),
        meta: {
          notLogged: true,
          requiresAuth: false,
          title: "Reenviar"
        }
      },
      // {
      //   path: "/perfil",
      //   name: "perfil",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "panel-admin" */ "@/views/menu/MisDatosView.vue"
      //     ),
      //   meta: {
      //     requiresAuth: true,
      //     title: "Perfil"
      //   }
      // },
      {
        path: "/editar",
        name: "editar",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/views/menu/editarPerfilView.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Editar"
        }
      },
      {
        path: "/configuracion",
        name: "configuracion",
        component: () =>
          import(
            /* webpackChunkName: "panel-admin" */ "@/views/menu/ConfiguracionView.vue"
          ),
        meta: {
          requiresAuth: true,
          title: "Configuración"
        }
      },
      {
        path: "/cuenta/eliminar",
        name: "EliminarCuenta",
        component: () =>
          import(
            /* webpackChunkName: "encuesta" */ "@/views/Web/EliminarCuentaView.vue"
          ),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: "/descargar",
        name: "Descarga",
        component: () =>
          import(
            /* webpackChunkName: "Descarga" */ "@/views/Descarga/DescargaView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Tarjeta Pircana"
        }
      },
      {
        path: "/actividades",
        name: "Actividades",
        component: () =>
          import(
            /* webpackChunkName: "noticias" */ "@/views/Actividades/GeneralView.vue"
          ),
        meta: {
          requiresAuth: false,
          title: "Actividades - Tarjeta Pircana"
        }
      },
      {
        path: "/actividades/publicacion/:nombre",
        name: "PublicacionAct",
        component: () =>
          import(
            /* webpackChunkName: "Publicacion" */ "@/views/Actividades/PublicacionView.vue"
          ),
        meta: {
          notLogged: false,
          requiresAuth: false,
          title: "Actividad - Tarjeta Pircana"
        }
      },
      {
        path: "/auth",
        name: "Auth",
        component: () =>
          import(/* webpackChunkName: "Auth" */ "@/views/auth/AuthView.vue"),
        meta: {
          requiresAuth: false,
          title: "Tarjeta Pircana"
        }
      },
      { path: "/:pathMatch(.*)", redirect: { name: "Home" } }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const authenticated = Store.state.authenticated;

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  const notLogged = to.matched.some(record => record.meta.notLogged);

  if (requiresAuth && !authenticated) {
    next("/login");
  } else if (!requiresAuth && authenticated) {
    if (notLogged) {
      next("/vecinos");
    } else {
      next();
    }
  } else {
    next();
  }
});

const DEFAULT_TITLE = "Tarjeta Pircana";
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = (to as any).meta.title || DEFAULT_TITLE;
  });
});

export default router;
